import React, { KeyboardEventHandler, useMemo, useState } from 'react'
import { Flex } from '@workwhile/ui'
import { useController, useFormContext } from 'react-hook-form'
import { ErrorMessage } from './ErrorMessage'
import { ShiftsTableSchema } from 'pages/Shifts/BulkCreateShifts/bulkCreateShiftsSchema'
import CreatableSelect from 'react-select/creatable'

export const WorkerIdsSelector = ({ shiftIndex }: { shiftIndex: number }) => {
  const { control } = useFormContext<ShiftsTableSchema>()
  const [inputValue, setInputValue] = useState('')

  const { field, fieldState } = useController({
    control,
    name: `shifts.${shiftIndex}.workerIds`,
  })

  const handleKeyDown: KeyboardEventHandler = (event) => {
    if (!inputValue) return
    switch (event.key) {
      case 'Enter':
      case 'Tab': {
        const newWorkerId = Number(inputValue)
        if (Number.isInteger(newWorkerId)) {
          const newWorkerIdsSet = new Set([...(field.value ?? []), newWorkerId])
          field.onChange(Array.from(newWorkerIdsSet))
          setInputValue('')
          event.preventDefault()
        }
      }
    }
  }

  const values = useMemo(() => {
    return field.value?.map((v) => ({
      label: v.toString(),
      value: v,
    }))
  }, [field.value])

  return (
    <Flex flexDirection="column" gap={1}>
      <CreatableSelect
        isClearable
        isMulti
        menuPortalTarget={document.body}
        components={{
          DropdownIndicator: null,
        }}
        inputValue={inputValue}
        placeholder="Type worker ID and press Enter"
        menuIsOpen={false}
        onChange={(newValues) => field.onChange(newValues?.map((v) => v.value))}
        onInputChange={(newValue) => setInputValue(newValue)}
        onKeyDown={handleKeyDown}
        value={values}
        styles={{
          container: (base) => ({
            ...base,
            width: '200px',
          }),
        }}
      />
      <ErrorMessage error={fieldState.error?.message} />
    </Flex>
  )
}
